// pages/TowClampDetail.js

import { useParams, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { firestore } from "../firebaseConfig";
import { doc, getDoc } from "firebase/firestore";
import { toast } from "react-toastify";

const TowClampDetail = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const docRef = doc(firestore, "tow_clamp_collection", id);
        const docSnap = await getDoc(docRef);

        if (docSnap.exists()) {
          setData({ id: docSnap.id, ...docSnap.data() });
        } else {
          toast.error("Record not found");
        }
      } catch (err) {
        console.error(err);
        toast.error("Error loading data");
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [id]);

  if (loading) return <p style={{ padding: "15px" }}>Loading...</p>;
  if (!data) return <p style={{ padding: "15px" }}>No data found</p>;

  return (
    <div style={styles.container}>
      
      {/* Back */}
      <button onClick={() => navigate(-1)} style={styles.back}>
        ⬅ Back
      </button>

      <h2>Case Detail</h2>

      {/* Main Info */}
      <div style={styles.card}>
        <p><b>Vehicle:</b> {data.vehicleNumber}</p>
        <p><b>Type:</b> {data.type}</p>
        <p><b>Vehicle Type:</b> {data.vehicleType}</p>
        <p><b>Reason:</b> {data.reason || "-"}</p>
        <p><b>Yard:</b> {data.yard || "-"}</p>
        <p><b>Amount:</b> ₹{data.amount || 0}</p>

        {data.createdAt && (
          <p style={styles.date}>
            {new Date(data.createdAt.seconds * 1000).toLocaleString()}
          </p>
        )}
      </div>

      {/* 📷 Vehicle Images */}
      {data.vehicleImages?.length > 0 && (
        <div style={styles.card}>
          <h3>Vehicle Photos</h3>
          <div style={styles.imageRow}>
            {data.vehicleImages.map((img, i) => (
              <img key={i} src={img} style={styles.image} />
            ))}
          </div>
        </div>
      )}

      {/* 📷 Number Plate */}
      {data.numberPlateImage && (
        <div style={styles.card}>
          <h3>Number Plate</h3>
          <img src={data.numberPlateImage} style={styles.imageLarge} />
        </div>
      )}

      {/* 📍 Location */}
      {data.location && data.location.latitude && (
        <div style={styles.card}>
          <h3>Location</h3>
          <p>
            Lat: {data.location.latitude} <br />
            Lng: {data.location.longitude}
          </p>

          <a
            href={`https://www.google.com/maps?q=${data.location.latitude},${data.location.longitude}`}
            target="_blank"
            rel="noreferrer"
            style={styles.mapBtn}
          >
            Open in Google Maps
          </a>
        </div>
      )}

    </div>
  );
};

const styles = {
  container: {
    padding: "12px",
    paddingBottom: "80px",
  },
  back: {
    marginBottom: "10px",
    border: "none",
    background: "transparent",
    fontSize: "14px",
    cursor: "pointer",
  },
  card: {
    background: "#fff",
    padding: "14px",
    borderRadius: "12px",
    marginBottom: "10px",
    boxShadow: "0 3px 10px rgba(0,0,0,0.08)",
  },
  imageRow: {
    display: "flex",
    gap: "8px",
    overflowX: "auto",
  },
  image: {
    width: "90px",
    height: "90px",
    borderRadius: "8px",
    objectFit: "cover",
  },
  imageLarge: {
    width: "100%",
    borderRadius: "10px",
  },
  mapBtn: {
    display: "block",
    marginTop: "10px",
    padding: "10px",
    background: "#3b82f6",
    color: "#fff",
    textAlign: "center",
    borderRadius: "8px",
    textDecoration: "none",
  },
  date: {
    fontSize: "12px",
    color: "#888",
    marginTop: "5px",
  },
};

export default TowClampDetail;